module.exports = __webpack_public_path__ + "static/media/AustinFC-FirstandOnly.145ccd8e.jpg";